import React from "react";
import { Pagination, ConfigProvider } from "antd";

const CommonPagination = ({
  current = 1,
  pageSize = 10,
  total = 0,
  onChange,
  style = {},
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#ec4899", // 🔥 pink utama
        },
        components: {
          Pagination: {
            colorPrimary: "#ec4899",
            colorPrimaryHover: "#ec4899",
            colorText: "#ec4899",
          },
        },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end", // 🔥 ini bikin ke kanan
          marginTop: 16,
        }}
      >
        <Pagination
          current={current}
          pageSize={pageSize}
          total={total}
          onChange={onChange}
        />
      </div>{" "}
    </ConfigProvider>
  );
};

export default CommonPagination;
